import { Button, Heading, Link, Wave } from '..';

interface VacanciesSectionProps {
  kicker?: string;
  title?: string;
  vacancies?: any;
  buttonText?: string;
}

export const VacanciesSection = ({
  kicker,
  title,
  vacancies,
  buttonText,
}: VacanciesSectionProps) => {
  return (
    <div
      id="vacancies"
      className="relative bg-yellow-100 md:bg-white md:max-w-6xl md:mx-auto md:px-4"
    >
      <div className="relative overflow-hidden bg-yellow-100 md:rounded-2xl mx-4 lg:mx-10">
        <Wave className="absolute w-full bottom-0 z-0 hidden md:block" />
        <div className="relative py-20 md:px-28 z-10">
          <Heading as="h6" variant="h6" className="font-sans mb-2 text-center">
            {kicker}
          </Heading>
          <Heading as="h3" variant="h3" className="mb-16 text-center">
            {title}
          </Heading>

          {vacancies?.map((category) => (
            <div key={category?._uid} className="mb-12">
              <Heading as="h6" variant="h6" className="font-sans mb-4">
                {category?.title}
              </Heading>

              {category?.jobs?.map((job) => {
                return (
                  <Link
                    key={job?.uuid}
                    href={`/${job?.full_slug}`}
                    className="bg-white w-full rounded-lg p-5 flex flex-col md:flex-row md:justify-between md:items-center md:p-8 mb-4 last:mb-0"
                  >
                    <div>
                      <Heading as="h5" variant="h5" className="mb-4">
                        {job?.content?.title}
                      </Heading>
                      <div className="flex text-gray-500 text-lg">
                        {job?.content?.keywords?.map((keyword) => (
                          <p
                            key={keyword?._uid}
                            className="text-lg text-grey-500 ml-6 first:ml-0"
                          >
                            {keyword?.text}
                          </p>
                        ))}
                      </div>
                    </div>
                    <Button
                      variant="light"
                      className="py-4 mt-8 md:mt-0 max-w-max"
                    >
                      {buttonText}
                    </Button>
                  </Link>
                );
              })}
            </div>
          ))}
        </div>
      </div>
      <Wave className="absolute w-full bottom-0 z-0 md:hidden" />
    </div>
  );
};
